import { DeviceFormFactor } from "common/render/form-factor";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setDeviceFormFactor } from "reducers/uistate";
import { AppDispatch } from "store/store";
import { getCurrentAppAndState } from "store/types";
import { useAppID } from "./use-app-id";
import { useBuilderSelector } from "./use-builder-selector";

export function useDeviceFormFactor() {
    const formFactor = useBuilderSelector(s => s.uiState.deviceFormFactor);
    const dispatch = useDispatch();
    const setFormFactor = useCallback(
        (newFormFactor: DeviceFormFactor) => {
            dispatch(setDeviceFormFactor(newFormFactor));
        },
        [dispatch]
    );

    return [formFactor, setFormFactor] as const;
}

export function useThunkDispatch() {
    return useDispatch<AppDispatch>();
}

export function useCurrentAppAndState() {
    const appID = useAppID();
    const appAndState = useBuilderSelector(s => getCurrentAppAndState(appID, s.apps));

    return [appAndState, appID] as const;
}
